import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { ActionModalButton } from '../../../../shared/components/action-modal/action-modal.interface';

@Component({
    selector: 'mapp-auth-session-timeout-warning-example',
    templateUrl: './session-timeout-warning-example.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class SessionTimeoutWarningExampleComponent implements OnInit {
    @Input() timer: BehaviorSubject<number>;

    primaryButton: ActionModalButton = {
        label: 'Log Out',
        action: () => this.logout(),
    };

    secondaryButton: ActionModalButton = {
        label: 'Continue',
        action: () => this.continue(),
    };

    description: string;

    showDescription: boolean;

    /**
     *
     */
    ngOnInit(): void {
        this.updateDescription();
    }

    /**
     *
     */
    private updateDescription() {
        this.timer.subscribe((time) => {
            if (this.showDescription) {
                this.description = `<p>Your session will expire in: ${this.minuteConvert(
                    time / 60
                )} mins ${time % 60} secs</p>
        <p>Please select 'Continue' to stay logged in or select 'Log out' to end your session now.</p>`;
            }
        });
    }

    /**
     *
     */
    logout() {
        this.description = null;
        this.showDescription = false;
    }

    /**
     *
     */
    continue() {
        this.description = null;
        this.showDescription = false;
    }

    /**
     *
     * @param minutes
     */
    minuteConvert(minutes: number) {
        return Math.floor(minutes);
    }
}
